"use client";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation,Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import styles from "./ToolPlatform.module.scss";

export default function ToolPlatform({ Heading, List }) {
  const [itemsToShow, setItemsToShow] = useState(5);

  useEffect(() => {
    setItemsToShow(window.innerWidth <= 768 ? 2 : 5); 
  }, []);

  const newList = List.length < 5  ? List : List.concat(List)

  return (
    <div className={styles.toolSection}>
      <div className={styles.headingBlock}>
        <h2 id="toolsplatform-heading">{Heading}</h2>
      </div>
      <div id="ToolPlatform-container" className={styles.carouselWrapper}>
        <Swiper
          spaceBetween={10} 
          slidesPerView={itemsToShow} 
          loop={true} 
          autoplay={{
            delay: 2000, 
            disableOnInteraction: false,
          }}
          // navigation={true} 
          modules={[Navigation,Autoplay]} 
          className={styles.toolSlider}
          breakpoints={{
            640: {
              slidesPerView: 2, 
            },
            768: {
              slidesPerView: 5, 
            },
          }}
        >
          {newList.map((item, index) => (
            <SwiperSlide key={index}>
              <div className={styles.owlitem}>
                <div className={styles.item}>
                  <div className={styles.toolitem}>
                    <img src={item.Image.data.attributes.url} alt={item.Image.data.attributes.alternativeText} />
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
